import {app} from '../../app';
import 'marked';
import IScope = angular.IScope;
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import IComponentController = angular.IComponentController;
import {SubmitSharedQuestion} from "../../sharedQuestions/SubmitSharedQuestion";
import ISCEService = angular.ISCEService;
import {UniqueIdService} from "../../services/UniqueIdService";
import ITimeoutService = angular.ITimeoutService;

export class SubmitQuestionComponent {

    protected sce:ISCEService;
    protected scope:IScope;
    protected timeout:ITimeoutService;
    protected uniqueIdService:UniqueIdService;
    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;

    sharedQuestion:SubmitSharedQuestion;
    question:IQuestion;
    nextQuestionCallback:() => void;
    previousQuestionCallback:() => void;
    showSessionPagination:boolean;
    hasPreviousQuestion:boolean;

    submitText = 'submit_questionnaire';
    facebookIFrameURL:string;
    joinResearchId:string;
    joinResearchValue:boolean;

    static $inject = ['$sce', '$scope', '$timeout', 'UniqueIdService', 'SharedQuestionService', 'SessionService'];

    constructor($sce:ISCEService, $scope:IScope, $timeout:ITimeoutService, uniqueIdService:UniqueIdService, sharedQuestionService:SharedQuestionService, sessionService:ISessionService) {
        this.sce                   = $sce;
        this.scope                 = $scope;
        this.timeout               = $timeout;
        this.uniqueIdService       = uniqueIdService;
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService        = sessionService;
    }

    $onInit() {
        this.sharedQuestion          = new SubmitSharedQuestion();
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0 && angular.isObject(answer.values[0])) {
            this.joinResearchValue = answer.values[0].joinResearchValue;
        }

        this.update();

        this.showSessionPagination = false;

        const title = this.sharedQuestion.question.title;
        if (title.length > 0) {
            this.submitText = title;
        }

        if (this.question.meta.social && this.question.meta.facebook) {
            this.facebookIFrameURL = this.sce.trustAsResourceUrl('https://www.facebook.com/plugins/like.php?href=' + encodeURIComponent(this.question.meta.facebook) + '&width=149&layout=button_count&action=like&size=large&show_faces=true&share=true&height=46');
        }

        if (this.question.meta.social && this.question.meta.research) {
            this.joinResearchId = this.uniqueIdService.getUniqueId('join-research');
        }
    }

    update(value?:boolean) {
        if (this.question.meta.social && this.question.meta.research) {
            this.sharedQuestion.setValue({
                value: true,
                joinResearchValue: value ? value : this.joinResearchValue
            });

            this.timeout(() => {
                this.scope.$apply();
            });
        }
    }

}

app.component('submitQuestion', {
    templateUrl : 'templates/components/questionTypes/submitQuestion.html',
    controller  : SubmitQuestionComponent,
    controllerAs: 'submitQuestion',
    bindings    : {
        question                : '<',
        nextQuestionCallback    : '&',
        previousQuestionCallback: '&',
        showSessionPagination   : '=',
        hasPreviousQuestion     : '='
    }
});